ceregoCommon.factory('GroupsSeriesResource', ['$resource', ($resource) ->
  $resource "", {},
    get:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_group_series_path(":group_id")
      params:
        group_id: "@group_id"
])
